import { useUserEventLogger } from '@repo/tracking-service';
import { Banner, BottomDrawer, Button } from '@zenterprise-inc/ui';
import { useMemo } from 'react';

import { INFOTECH_BANK } from '@/lib/constants/bank';

interface CheckAccountNameDrawerProps {
  isVisible: boolean;
  onCloseDrawer: () => void;
  onClickYes: () => void;
  accountName: string;
  account: {
    bankId: string;
    accountNumber: string;
  };
  title: string;
}

export const CheckAccountNameDrawer = ({ isVisible, onCloseDrawer, onClickYes, accountName, account, title }: CheckAccountNameDrawerProps) => {
  const { pageName, sendClickEvent, sendViewEvent } = useUserEventLogger();

  if (isVisible) {
    sendViewEvent(`${pageName}_bankaccount_confirm-bank`, undefined, { isAllowRetry: true });
  }

  const bankIconFileName = INFOTECH_BANK.find((bankData) => bankData.bankId === account.bankId)?.bankIconFileName ?? 'logo_nh';

  const bankName = useMemo(() => {
    return INFOTECH_BANK.find(({ bankId }) => bankId === account.bankId)?.bankName || '';
  }, [account]);

  const handleClickModify = () => {
    sendClickEvent(`${pageName}_bankaccount_modify-bank`);
    onCloseDrawer();
  };

  const handleClickYes = () => {
    sendClickEvent(`${pageName}_bankaccount_next-bank`);
    onClickYes();
  };

  return (
    <BottomDrawer.Basic isVisible={isVisible} isStretchable={false} onCloseDrawer={onCloseDrawer}>
      <BottomDrawer.Basic.Header onCloseDrawer={onCloseDrawer}>{title}</BottomDrawer.Basic.Header>
      <BottomDrawer.Basic.Contents isBottomButton>
        <div className="px-6 pt-3">
          <Banner.RightAction
            title={accountName}
            subText={`${bankName} ${account.accountNumber}`}
            illustIcon={
              <img src={`${process.env.NEXT_PUBLIC_RESOURCE_CENTER_URL}/common/logo/external/${bankIconFileName}.svg`} className={'w-9 h-9'} alt={''} />
            }
          />
        </div>
      </BottomDrawer.Basic.Contents>
      <BottomDrawer.Basic.BottomButton>
        <Button.StickyBottom.Button onClick={handleClickModify}>계좌 수정</Button.StickyBottom.Button>
        <Button.StickyBottom.Button state="primary" onClick={handleClickYes}>
          네, 맞아요
        </Button.StickyBottom.Button>
      </BottomDrawer.Basic.BottomButton>
    </BottomDrawer.Basic>
  );
};
